"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDayButtonStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _createFocusRingStyles = require("../../../../util/createFocusRingStyles");
var _clickable = require("../../../clickable");
var _DatePickerDay = require("../components/DatePickerDay");
var _datePickerTheme = require("./datePickerTheme");
const shouldForwardProp = propName => {
  switch (propName) {
    // NOT blocking `isDisabled` so it gets forwarded on to the Clickable.
    case "focusMode":
    case "isSelected":
    case "isToday":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
const getKeyboardStyles = (isSelected, _isToday, themeMode) => `
    &:focus {
        background-color: ${_datePickerTheme.datePickerTheme.backgroundColor};
        // Make sure a selected element shows above its peers
        // so the focus ring will not be occluded.
        z-index: 1;
        box-shadow: 0px 0px 0px 3px #ffffff;
    }

    ${isSelected ? `
                &,
                &:focus {
                    background-color: ${_datePickerTheme.datePickerTheme.dayBackgroundColorSelected[themeMode]};

                    & .${_DatePickerDay.DAY_STYLED_CLASS_NAME} {
                        color: ${_datePickerTheme.datePickerTheme.dayColorSelected[themeMode]};
                        font-weight: ${_datePickerTheme.datePickerTheme.dayFontWeightSelected[themeMode]};
                    }
                }                   
            ` : ""}
`;
const getMouseStyles = (isSelected, isToday, themeMode) => `

    &:hover {
        background-color: ${isToday ? _datePickerTheme.datePickerTheme.dayBackgroundColorTodayHover[themeMode] : _datePickerTheme.datePickerTheme.dayBackgroundColorHover[themeMode]};
    }

    &:active {
        background-color: ${isToday ? _datePickerTheme.datePickerTheme.dayBackgroundColorTodayActive[themeMode] : _datePickerTheme.datePickerTheme.dayBackgroundColorActive[themeMode]};
    }

    ${isSelected ? `
            &,
            &:hover,
            &:active {
                background-color: ${_datePickerTheme.datePickerTheme.dayBackgroundColorSelected[themeMode]};

                & .${_DatePickerDay.DAY_STYLED_CLASS_NAME} {
                    color: ${_datePickerTheme.datePickerTheme.dayColorSelected[themeMode]};
                    font-weight: ${_datePickerTheme.datePickerTheme.dayFontWeightSelected[themeMode]};
                }
            }
        ` : ""}
`;
const getDisabledStyles = _ref => {
  let {
    isDisabled,
    themeMode
  } = _ref;
  return isDisabled ? `
            cursor: not-allowed;

            &,
            &:focus,
            &:hover,
            &:active {
                background-color: transparent;

                & .${_DatePickerDay.DAY_STYLED_CLASS_NAME} {
                    color: ${_datePickerTheme.datePickerTheme.dayColorDisabled[themeMode]};
                    ${(0, _datePickerTheme.getDisabledBumperStyles)({
    themeMode
  })}
                }
            }
        ` : "";
};
const DatePickerDayButtonStyled = (0, _styled.default)(_clickable.Clickable, {
  shouldForwardProp
})`
    box-sizing: border-box;
    border: 2px solid transparent;
    border-radius: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _datePickerTheme.datePickerTheme.dayBorderRadius[themeMode];
}};

    height: ${_designTokens.space.space60};
    width: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _datePickerTheme.datePickerTheme.dayWidth[themeMode];
}};
    color: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _datePickerTheme.datePickerTheme.dayColor[themeMode];
}};

    ${_ref5 => {
  let {
    isInRange,
    isToday,
    themeMode
  } = _ref5;
  return isToday && `
            ${!isInRange ? `background-color: ${_datePickerTheme.datePickerTheme.dayBackgroundColorToday[themeMode]};` : ""};
            border-color: ${_datePickerTheme.datePickerTheme.dayBorderColorToday[themeMode]};
            & .${_DatePickerDay.DAY_STYLED_CLASS_NAME} {
                color: ${_datePickerTheme.datePickerTheme.dayColorToday[themeMode]};
                font-weight: ${_datePickerTheme.datePickerTheme.dayFontWeightToday[themeMode]};
            }
        `;
}}
    // We need to treat a LOT of the styles differently if we are in keyboard or mouse mode.
    ${_ref6 => {
  let {
    focusMode,
    isSelected,
    isToday,
    themeMode
  } = _ref6;
  return focusMode === "keyboard" ? getKeyboardStyles(isSelected, isToday, themeMode) : getMouseStyles(isSelected, isToday, themeMode);
}}
    ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    gap: _datePickerTheme.datePickerTheme.dayFocusRingGap[themeMode],
    componentBorderWidth: 2,
    componentRadius: _datePickerTheme.datePickerTheme.dayBorderRadius[themeMode],
    secondaryWidth: 0
  });
}}
    // Putting this last so it always wins.
    ${getDisabledStyles};
`;
exports.DatePickerDayButtonStyled = DatePickerDayButtonStyled;
//# sourceMappingURL=DatePickerDayButtonStyled.js.map